import { render, staticRenderFns } from "./RecordListBase.vue?vue&type=template&id=1c48a5da&scoped=true&"
import script from "./RecordListBase.vue?vue&type=script&lang=js&"
export * from "./RecordListBase.vue?vue&type=script&lang=js&"
import style0 from "./RecordListBase.vue?vue&type=style&index=0&id=1c48a5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48a5da",
  null
  
)

export default component.exports